import axios from "axios";
import { GURL } from "./global";

axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "token"
)}`;

export const GetCompanyParticipantCountByCompanyIdAndParticipantId = (
  companyParticipantId: any
) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Company/v1/TransactionParticipants/GetCompanyParticipantCountByCompanyIdAndParticipantId?CompanyParticipantId=${companyParticipantId}`;
  return axios.get(url);
};
